<template>
  <div class="taller-express">
    <!-- Barra de navegación REDISEÑADA - altura reducida -->
    <v-app-bar
      class="taller-appbar"
      color="#FF9800"
      dark
      elevate-on-scroll
      flat
      height="64"
    >
      <v-btn icon class="back-button" @click="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <div class="logo-wrapper">
        <v-icon class="logo-icon" size="28">mdi-car-wrench</v-icon>
        <span class="logo-text">TALLER EXPRESS</span>
      </div>

      <v-spacer></v-spacer>

      <div class="nav-links d-none d-md-flex">
        <a href="#inicio" class="nav-link" @click.prevent="scrollToSection('inicio')"
          >Inicio</a
        >
        <a
          href="#servicios"
          class="nav-link"
          @click.prevent="scrollToSection('servicios')"
          >Servicios</a
        >
        <a href="#contacto" class="nav-link" @click.prevent="scrollToSection('contacto')"
          >Contacto</a
        >
        <a href="tel:+51917915824" class="nav-link phone-link">
          <v-icon small class="mr-1">mdi-phone</v-icon>
          +51 928 180 748
        </a>
      </div>
    </v-app-bar>

    <!-- Hero Section (resto del contenido igual) -->
    <section id="inicio" class="hero-section">
      <v-parallax
        class="hero-parallax"
        src="https://images.unsplash.com/photo-1487754180451-c456f719a1fc"
        :height="520"
      >
        <div class="hero-overlay"></div>
        <v-container fill-height>
          <v-row align="center" justify="center" class="text-center hero-row">
            <v-col cols="12" md="8">
              <h1 class="display-3 font-weight-bold white--text hero-title">
                Taller Express
              </h1>
              <h2 class="headline white--text mb-6 hero-subtitle">
                Mecánica rápida y confiable
              </h2>
              <v-btn class="hero-button" dark x-large rounded @click="openCotizador">
                Cotizar ahora
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-parallax>
    </section>

    <!-- Servicios Section -->
    <section id="servicios" class="services-section">
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center">
            <h2 class="display-1 font-weight-bold section-heading">
              Servicios Mecánicos
            </h2>
            <p class="section-subheading">Soluciones profesionales para tu vehículo</p>
          </v-col>
        </v-row>

        <v-row class="mt-8">
          <v-col v-for="service in servicios" :key="service.name" cols="12" md="4">
            <v-card class="service-card text-center pa-8" elevation="5" hover>
              <v-icon size="64" color="#FF9800">{{ service.icon }}</v-icon>
              <h3 class="title mt-4">{{ service.name }}</h3>
              <p class="service-description">{{ service.description }}</p>
              <div class="service-price">{{ service.price }}</div>
              <v-btn class="service-action" outlined @click="selectService(service.name)">
                Seleccionar
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Cotizador Section -->
    <section id="cotizador" class="cotizador-section">
      <v-container>
        <v-card class="cotizador-card pa-6 pa-md-8" elevation="10">
          <h2 class="text-center display-1 mb-2 section-heading">Cotización Rápida</h2>
          <p class="text-center mb-6 cotizador-subtitle">
            Completa los datos y obtén un presupuesto estimado
          </p>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="cotizacion.marca"
                :items="marcas"
                label="Marca"
                outlined
                dense
                :error="errors.marca"
                :error-messages="errors.marca"
                @change="clearError('marca')"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="cotizacion.modelo"
                :items="getModelosFiltrados"
                label="Modelo"
                outlined
                dense
                :disabled="!cotizacion.marca"
                :error="errors.modelo"
                :error-messages="errors.modelo"
                @change="clearError('modelo')"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="cotizacion.servicio"
                :items="servicios.map((s) => s.name)"
                label="Servicio"
                outlined
                dense
                :error="errors.servicio"
                :error-messages="errors.servicio"
                @change="clearError('servicio')"
              ></v-select>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                class="calc-button"
                dark
                large
                :loading="calculando"
                @click="calcularCotizacion"
              >
                <v-icon left>mdi-calculator</v-icon>
                {{
                  cotizacion.precio
                    ? `S/ ${cotizacion.precio.toFixed(2)}`
                    : "Calcular cotización"
                }}
              </v-btn>
              <v-btn
                v-if="cotizacion.precio"
                text
                class="reset-button ml-4"
                @click="resetCotizacion"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Nueva cotización
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </section>

    <!-- Footer / Contacto -->
    <footer id="contacto" class="footer-section">
      <v-container>
        <v-row>
          <v-col cols="12" md="4" class="text-center text-md-left">
            <h4 class="footer-title">
              <v-icon small color="#FF9800">mdi-car-wrench</v-icon>
              Taller Express
            </h4>
            <p class="footer-text">Mecánica rápida y confiable desde 2010</p>
          </v-col>
          <v-col cols="12" md="4" class="text-center">
            <h5 class="footer-subtitle">Horario de atención</h5>
            <p class="footer-text">
              Lun - Vie: 8:00am - 7:00pm<br />Sábado: 9:00am - 2:00pm
            </p>
          </v-col>
          <v-col cols="12" md="4" class="text-center text-md-right">
            <h5 class="footer-subtitle">Contáctanos</h5>
            <p class="footer-text">
              <v-icon x-small class="mr-1">mdi-phone</v-icon> +51 928 180 748<br />
              <v-icon x-small class="mr-1">mdi-email</v-icon> info@tallerexpress.com
            </p>
          </v-col>
        </v-row>
        <v-divider class="my-4" dark></v-divider>
        <div class="text-center footer-copyright">
          &copy; {{ new Date().getFullYear() }} Taller Express - Todos los derechos
          reservados
        </div>
      </v-container>
    </footer>
  </div>
</template>

<script>
export default {
  name: "TallerExpress",
  data() {
    return {
      servicios: [
        {
          name: "Mantenimiento",
          icon: "mdi-oil",
          description: "Cambio de aceite y filtros. Revisión general del motor.",
          price: "S/ 150",
          basePrice: 150,
        },
        {
          name: "Frenos",
          icon: "mdi-car-brake-abs",
          description: "Pastillas, discos y líquido de frenos. Máxima seguridad.",
          price: "S/ 200",
          basePrice: 200,
        },
        {
          name: "Motor",
          icon: "mdi-engine",
          description: "Diagnóstico computarizado y reparación especializada.",
          price: "Desde S/ 500",
          basePrice: 500,
        },
      ],
      marcas: ["Toyota", "Nissan", "Hyundai", "Kia", "Chevrolet"],
      modelosPorMarca: {
        Toyota: ["Corolla", "Yaris", "Hilux", "Rav4"],
        Nissan: ["Sentra", "Versa", "March", "X-Trail"],
        Hyundai: ["Elantra", "Tucson", "Accent", "Santa Fe"],
        Kia: ["Rio", "Sportage", "Cerato", "Sorento"],
        Chevrolet: ["Sail", "Spark", "Onix", "Tracker"],
      },
      cotizacion: {
        marca: "",
        modelo: "",
        servicio: "",
        precio: null,
      },
      errors: {
        marca: "",
        modelo: "",
        servicio: "",
      },
      calculando: false,
    };
  },
  computed: {
    getModelosFiltrados() {
      if (!this.cotizacion.marca) return [];
      return this.modelosPorMarca[this.cotizacion.marca] || [];
    },
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = "/portafolio";
      }
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    openCotizador() {
      const cotizadorSection = document.getElementById("cotizador");
      if (cotizadorSection) {
        cotizadorSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    selectService(serviceName) {
      this.cotizacion.servicio = serviceName;
      this.openCotizador();
    },
    clearError(field) {
      this.errors[field] = "";
    },
    validateForm() {
      let isValid = true;
      if (!this.cotizacion.marca) {
        this.errors.marca = "Selecciona una marca";
        isValid = false;
      }
      if (!this.cotizacion.modelo) {
        this.errors.modelo = "Selecciona un modelo";
        isValid = false;
      }
      if (!this.cotizacion.servicio) {
        this.errors.servicio = "Selecciona un servicio";
        isValid = false;
      }
      return isValid;
    },
    async calcularCotizacion() {
      if (!this.validateForm()) return;

      this.calculando = true;

      setTimeout(() => {
        const servicioSeleccionado = this.servicios.find(
          (s) => s.name === this.cotizacion.servicio
        );
        let basePrice = servicioSeleccionado?.basePrice || 300;

        const marcaFactor = {
          Toyota: 1.0,
          Nissan: 1.05,
          Hyundai: 0.95,
          Kia: 0.9,
          Chevrolet: 1.0,
        };
        const factor = marcaFactor[this.cotizacion.marca] || 1.0;

        this.cotizacion.precio = Math.round(basePrice * factor * 100) / 100;
        this.calculando = false;
      }, 800);
    },
    resetCotizacion() {
      this.cotizacion = {
        marca: "",
        modelo: "",
        servicio: "",
        precio: null,
      };
      this.errors = {
        marca: "",
        modelo: "",
        servicio: "",
      };
    },
  },
};
</script>

<style scoped>
.taller-express {
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  background: #f8f9fc;
  color: #1a1c2c;
}

/* ========== MENÚ REDISEÑADO ========== */
.taller-appbar {
  background: rgba(10, 15, 25, 0.92) !important;
  backdrop-filter: blur(12px);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08) !important;
  border-bottom: 1px solid rgba(255, 152, 0, 0.2);
  height: 64px !important;
  transition: all 0.3s ease;
}

.taller-appbar.v-app-bar--is-scrolled {
  background: rgba(10, 15, 25, 0.98) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}

.taller-appbar .v-toolbar__content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  height: 64px !important;
}

/* Logo */
.logo-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}

.logo-icon {
  color: #ff9800;
  filter: drop-shadow(0 2px 4px rgba(255, 152, 0, 0.3));
}

.logo-text {
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: white;
  background: linear-gradient(135deg, #fff, #ffcd7e);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}

/* Navegación links */
.nav-links {
  display: flex;
  align-items: center;
  gap: 6px;
}

.nav-link {
  text-decoration: none;
  color: #e5e7eb;
  font-weight: 500;
  font-size: 0.9rem;
  padding: 8px 18px;
  border-radius: 40px;
  transition: all 0.2s ease;
  letter-spacing: 0.3px;
  position: relative;
  cursor: pointer;
}

.nav-link:hover {
  color: #ff9800;
  background: rgba(255, 152, 0, 0.08);
}

/* Link del teléfono - estilo destacado */
.phone-link {
  background: rgba(255, 152, 0, 0.12);
  border: 1px solid rgba(255, 152, 0, 0.3);
  margin-left: 8px;
}

.phone-link:hover {
  background: #ff9800;
  color: #1a1c2c !important;
  border-color: #ff9800;
}

.phone-link:hover .v-icon {
  color: #1a1c2c !important;
}

/* Botón back */
.back-button {
  color: white !important;
  margin-right: 4px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 40px !important;
}

/* ========== RESTO DE ESTILOS ========== */
.hero-parallax {
  position: relative;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.4) 100%);
  z-index: 1;
}

.hero-row {
  position: relative;
  z-index: 2;
}

.hero-title {
  letter-spacing: -0.03em;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  margin-bottom: 16px;
}

.hero-subtitle {
  font-weight: 400;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.hero-button {
  background: linear-gradient(135deg, #ff9800, #f57c00) !important;
  color: #fff !important;
  font-weight: 700 !important;
  text-transform: none !important;
  box-shadow: 0 8px 28px rgba(245, 124, 0, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.hero-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(245, 124, 0, 0.45);
}

.section-heading {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 700;
  background: linear-gradient(135deg, #1a1c2c, #3a3d5e);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  margin-bottom: 8px;
}

.section-subheading {
  color: #6b7280;
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
}

.services-section {
  padding: 64px 0;
}

.service-card {
  border-radius: 24px;
  min-height: 380px;
  background: #ffffff;
  transition: all 0.3s cubic-bezier(0.2, 0, 0, 1);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.service-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.12);
}

.service-description {
  color: #6b7280;
  line-height: 1.6;
  margin: 16px 0;
  min-height: 80px;
}

.service-price {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ff9800;
  margin: 16px 0;
}

.service-action {
  border-color: #ff9800 !important;
  color: #ff9800 !important;
  font-weight: 600 !important;
  text-transform: none !important;
}

.cotizador-section {
  padding: 64px 0;
  background: linear-gradient(180deg, #f8f9fc 0%, #fff 100%);
}

.cotizador-card {
  border-radius: 32px;
  background: #ffffff;
  border: 1px solid rgba(255, 152, 0, 0.15);
}

.cotizador-subtitle {
  color: #6b7280;
}

.calc-button {
  background: linear-gradient(135deg, #ff9800, #f57c00) !important;
  color: #fff !important;
  font-weight: 700 !important;
  text-transform: none !important;
  padding: 12px 32px !important;
  box-shadow: 0 6px 20px rgba(255, 152, 0, 0.3);
}

.reset-button {
  color: #6b7280 !important;
}

.footer-section {
  background: #1a1c2c;
  color: #e5e7eb;
  padding: 48px 0 24px;
}

.footer-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #ff9800;
}

.footer-subtitle {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 12px;
  color: #f3f4f6;
}

.footer-text {
  color: #9ca3af;
  font-size: 0.9rem;
  line-height: 1.6;
}

.footer-copyright {
  color: #6b7280;
  font-size: 0.8rem;
}

@media (max-width: 960px) {
  .hero-parallax {
    height: auto !important;
    min-height: 480px;
  }

  .hero-title {
    font-size: 2.8rem !important;
  }

  .services-section,
  .cotizador-section {
    padding: 48px 16px;
  }
}

@media (max-width: 600px) {
  .hero-title {
    font-size: 2rem !important;
  }

  .hero-subtitle {
    font-size: 1rem !important;
  }

  .service-card {
    min-height: auto;
  }

  .logo-text {
    font-size: 0.85rem;
    letter-spacing: 1px;
  }
}
</style>
